import React from "react"
import ClassNames from "classnames"

export const SubMenuList = (props: {
  cls: string
  list: Array<{
    icon: string | React.ReactElement
    iconSvg?: Function
    cls: string
    materialCls?: string
    name: string
    onClick: Function
    onMouseOver?: Function
    onMouseLeave?: Function
    component?: Function
  }>
}) => {
  return (
    <ul className={`${props.cls}-list`}>
      {props.list.map((row, i) => (
        <li
          key={i}
          className={ClassNames(`${props.cls}-item btn ripple`, row.cls)}
          onClick={() => row.onClick()}
          onMouseOver={() => row.onMouseOver && row.onMouseOver()}
          onMouseLeave={() => row.onMouseLeave && row.onMouseLeave()}
        >
          {typeof row.icon === "string" && row.icon ? (
            <i className={ClassNames("material-icons", row.materialCls)}>
              {row.icon}
            </i>
          ) : (
            row.icon
          )}
          {!!row.iconSvg ? (
            <span className="material-icons-svg">{row.iconSvg()}</span>
          ) : null}
          <div className={`${props.cls}-item-title`}>
            {!!row.name ? <span>{row.name}</span> : null}
            {!!row.component ? row.component() : null}
          </div>
        </li>
      ))}
    </ul>
  )
}
